import { TippyV2 } from "@circle-react/components/shared/TippyV2";
import { useRecurringFrequencyLabel } from "../../hooks/useRecurringFrequencyLabel";

interface EventIconTooltipProps {
  children: React.ReactNode;
  disabled?: boolean;
  frequency: string;
  startsAt: string;
}

export const EventIconTooltip = ({
  startsAt,
  frequency,
  disabled = false,
  children,
}: EventIconTooltipProps) => {
  const { label } = useRecurringFrequencyLabel({ startsAt, frequency });

  return (
    <TippyV2 placement="bottom" content={label} disabled={disabled}>
      {children}
    </TippyV2>
  );
};
